import React, { useContext } from 'react';
import {
	ApButtonIcon,
	ApButtonTab,
	ApSecondaryNav,
} from '@alixpartners/ui-components';
import { CategoryPageWrapper, ContentDiv } from './styles';
import { CONFIG } from './routes';
import {
	NavLink,
	Redirect,
	Route,
	Switch,
} from 'react-router-dom/cjs/react-router-dom.min';
import Insights from './Insights/Insights';
import VendorSegmentation from './VendorSegmentation/VendorSegmentation';
import Dashboard from './Dashboard/Dashboard.js';
import withCategoryManagementProviders from './HOCs/withCategoryManagementProviders';
import withCategoryManagementInsightsProviders from './HOCs/withCategoryManagementInsightsProviders';
import withCategoryManagementDashboardProviders from './HOCs/withCategoryManagementDashboardProviders';
import withCategoryManagementVendorSegmentationProviders from './HOCs/withCategoryManagementVendorSegmentationProviders';
import CustomFilters from './Components/CustomFilters/CustomFilters.js';
import { CustomFilterOptionWrapper } from './CategoryManagement.styles';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';

const ContentComponent = {
	insights: withCategoryManagementInsightsProviders(Insights),
	dashboard: withCategoryManagementDashboardProviders(Dashboard),
	vendorSegmentation: withCategoryManagementVendorSegmentationProviders(
		VendorSegmentation
	),
};

export const CategoryManagement = props => {
	const { location } = props;
	const {
		customFilters,
		customFiltersValues,
		handleCustomFilterChange,
	} = useContext(CategoryManagementContext);
	const isClearVisible = customFiltersValues && customFiltersValues.length > 0;

	const clearAllFilters = () => {
		handleCustomFilterChange({
			customFilters: [],
			customFiltersValues: [],
		});
	};

	return (
		<CategoryPageWrapper>
			<ApSecondaryNav
				left={
					<React.Fragment>
						{CONFIG.map(({ label, path }) => {
							return (
								<NavLink to={path} key={path}>
									<ApButtonTab isSelected={location.pathname.includes(path)}>
										{label}
									</ApButtonTab>
								</NavLink>
							);
						})}
					</React.Fragment>
				}
				right={
					<CustomFilterOptionWrapper>
						<CustomFilters
							customFilters={customFilters}
							customFiltersValues={customFiltersValues}
						/>
						{isClearVisible && (
							<ApButtonIcon iconName="close" onClick={clearAllFilters} />
						)}
					</CustomFilterOptionWrapper>
				}
			/>
			<ContentDiv>
				<Switch>
					{CONFIG.map(({ name, path }) => {
						return (
							<Route
								key={path}
								path={path}
								component={ContentComponent[name]}
							/>
						);
					})}
					<Redirect to={CONFIG[0].path} />
				</Switch>
			</ContentDiv>
		</CategoryPageWrapper>
	);
};

export default withCategoryManagementProviders(CategoryManagement);
